import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { CallLinkService, LinkDialogRequest } from '@callcenter-app/service/call-link.service';
import { formatPhone } from '@callcenter-app/pages/orders-archive/orders-archive.format';
import { OrderLiveIconComponent } from '@callcenter-app/components/order-live/order-live-icon.component';

/** What the window says: the order, the number of the call, and the key of the sentence about what was done. */
export interface CallLinkDialogView {
  orderNumber: string;
  phone: string;
  doneKey: string;
}

/**
 * «Привязать текущий звонок к заказу №…?» (design §3.5): the operator did something to an order during a call, and the number of the call is not the order's. ONE window for the application (in the shell, `home.component.html`),
 * fed by `CallLinkService.dialog$`: the requests queue, the first one is shown. «Не привязывать» and «Привязать» are the only ways out — a click outside or Esc is not an answer (the decision stays for the call). A second click on
 * the same window answers once.
 */
@Component({
  selector: 'app-call-link-dialog',
  templateUrl: './call-link-dialog.component.html',
  styleUrls: ['./call-link-dialog.component.css'],
  imports: [NgIf, TranslocoPipe, NzModalModule, OrderLiveIconComponent],
})
export class CallLinkDialogComponent implements OnInit, OnDestroy {
  visible = false;
  /** Kept after the window closes, so that it does not empty itself while it fades out. */
  view?: CallLinkDialogView;

  private current?: LinkDialogRequest;
  private answered?: LinkDialogRequest;
  private subscription?: Subscription;

  constructor(private link: CallLinkService) {
  }

  ngOnInit(): void {
    this.subscription = this.link.dialog$.subscribe(request => {
      this.current = request;
      this.visible = !!request;
      if (request) {
        this.view = { orderNumber: request.orderNumber, phone: formatPhone(request.phone) ?? request.phone, doneKey: 'callLink.done.' + request.done };
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  answer(accept: boolean): void {
    if (!this.current || this.answered === this.current) {
      return;
    }
    this.answered = this.current;
    this.link.answer(accept);
  }
}
